// TODO - add HS code here. This file exists to keep other app bundle files from
// accessing the HS global object. (CC)
export default global.HelloSign || {};
